module.exports = __webpack_public_path__ + "img/view.f5528e5e.svg";